// SEO landing page configs. Each renders via <SeoLandingPage config={...}/>.
// Edit copy/highlights here to tune on-page SEO for each target keyword.
export const SEO_PAGES = {
  "homestead-fl": {
    path: "/drone-crop-spraying-homestead-fl/",
    title: "Drone Crop Spraying in Homestead, FL | AeroAcres",
    h1: "Drone Crop Spraying in Homestead, Florida",
    intro:
      "AeroAcres is the trusted FAA Part 137 certified drone spray service for growers across Homestead, FL. From avocado groves and lime orchards to tomato rows and ornamental nurseries, our pilots cover South Miami-Dade's unique limestone-soil fields with precision and speed.",
    bullets: [
      "FAA Part 137 + Part 107 certified drone pilots",
      "Same-day mobilization for pest and disease emergencies",
      "Precision GPS swath control — 20–30% chemical savings",
      "Avocado, mango, lime, tomato, squash and nursery experience",
      "Same-week scheduling across the entire Homestead area",
    ],
    crops: ["Avocado", "Mango", "Lime", "Tomato", "Squash", "Beans", "Ornamental Nursery"],
    nearby: ["miami-dade", "redland-fl", "avocado-groves"],
    metaDescription:
      "FAA Part 137 certified drone crop spraying in Homestead, FL. Pesticide, herbicide, fungicide and fertilizer application for avocado, mango, citrus and row crops. Free quote — call 786-384-5030.",
  },
  "miami-dade": {
    path: "/drone-crop-spraying-miami-dade/",
    title: "Drone Crop Spraying in Miami-Dade County | AeroAcres",
    h1: "Drone Crop Spraying for Miami-Dade County Farms",
    intro:
      "Miami-Dade's agriculture stretches from the Krome Avenue row-crop belt to dense Redland groves and ornamental nurseries. AeroAcres covers the entire county with FAA-licensed drone applicators — fast scheduling, precision spraying, and full coverage reports.",
    bullets: [
      "Serving Homestead, Florida City, Princeton, Naranja, Cutler Bay and Redland",
      "Same-week scheduling, 24–48 hour emergency response",
      "Specialized in tropical fruit groves and high-canopy crops",
      "EPA-compliant chemical sourcing on request",
      "Full GPS flight logs for organic and crop-insurance audits",
    ],
    crops: ["Avocado", "Mango", "Sweet Corn", "Tomato", "Beans", "Sugarcane", "Citrus", "Nursery"],
    nearby: ["homestead-fl", "redland-fl", "cost-florida"],
    metaDescription:
      "Drone crop spraying across Miami-Dade County. AeroAcres FAA-certified pilots handle pesticide, fungicide, fertilizer and seeding for row crops, groves and nurseries. Free quote: 786-384-5030.",
  },
  "redland-fl": {
    path: "/agricultural-drone-spraying-redland-fl/",
    title: "Agricultural Drone Spraying in the Redland, FL | AeroAcres",
    h1: "Agricultural Drone Spraying in the Redland Agricultural Area",
    intro:
      "The Redland is one of Florida's most diverse agricultural zones — and one of the hardest to spray with conventional ground rigs. AeroAcres' drone fleet handles dense tropical-fruit canopies, narrow nursery rows and limestone-edge fields without leaving a tire track.",
    bullets: [
      "Zero soil compaction — critical for the Redland's rocky soils",
      "Dense-canopy specialists: downwash drives chemical to leaf undersides",
      "Coordinated bee-safe spray windows with on-site apiaries",
      "Tight buffers respected near residential and conservation borders",
      "Compatible with organic-program chemistries and biologicals",
    ],
    crops: ["Avocado", "Mango", "Lime", "Lychee", "Longan", "Specialty Tropicals", "Ornamental Nursery"],
    nearby: ["homestead-fl", "avocado-groves", "miami-dade"],
    metaDescription:
      "Agricultural drone spraying across the Redland Agricultural Area in South Miami-Dade. Precision drone application for tropical fruit, nurseries and specialty crops. Get a free quote: 786-384-5030.",
  },
  "avocado-groves": {
    path: "/drone-spraying-avocado-groves/",
    title: "Drone Spraying for Avocado Groves in Florida | AeroAcres",
    h1: "Drone Spraying for Avocado Groves",
    intro:
      "Florida avocado growers face laurel wilt, scale, mites and recurring fungal pressure under dense canopy. Conventional sprayers struggle to penetrate the upper crown — drones don't. AeroAcres applies fungicide, miticide and foliar nutrition directly into the canopy from above, where it matters.",
    bullets: [
      "Top-down canopy penetration with controlled downwash",
      "Multi-pass overlap programs for hard-to-reach laurel wilt zones",
      "Foliar nutrition + fungicide tank-mixes in a single flight",
      "Recurring monthly or bi-weekly grove programs",
      "Flight logs and GPS coverage maps for every application",
    ],
    crops: ["Avocado (Hass, Lula, Choquette, Monroe)"],
    nearby: ["homestead-fl", "redland-fl", "miami-dade"],
    metaDescription:
      "Drone spraying built for Florida avocado growers. Fungicide, miticide and foliar nutrition applied directly into dense canopy from above. AeroAcres Homestead, FL. Call 786-384-5030.",
  },
  "cost-florida": {
    path: "/farm-drone-spraying-cost-florida/",
    title: "How Much Does Drone Spraying Cost in Florida? | AeroAcres",
    h1: "How Much Does Farm Drone Spraying Cost in Florida?",
    intro:
      "Drone spray pricing in South Florida depends on the service type, crop, acreage, chemical and access. Below is a transparent breakdown of what most growers pay across Homestead, Miami-Dade and Broward — and where you can save.",
    bullets: [
      "Pesticide application: typically $15–$25 per acre",
      "Herbicide spraying: typically $14–$22 per acre",
      "Fungicide treatment: typically $18–$26 per acre",
      "Liquid fertilizer / foliar: typically $13–$20 per acre",
      "Cover-crop seeding: typically $10–$15 per acre",
      "Volume discounts above 50 acres — rush fees apply for same-day jobs",
    ],
    crops: ["All Florida row, grove and nursery crops"],
    nearby: ["homestead-fl", "miami-dade", "guide"],
    metaDescription:
      "What does drone crop spraying cost in Florida? A transparent breakdown of per-acre pricing for pesticide, herbicide, fungicide, fertilizer and seeding across South Florida. Free quote: 786-384-5030.",
  },
  "pesticide-florida": {
    path: "/drone-pesticide-spraying-florida/",
    title: "Drone Pesticide Spraying in Florida | AeroAcres",
    h1: "Drone Pesticide Spraying in Florida",
    intro:
      "From thrips and whitefly on tomatoes to scale and mites in citrus and avocado, AeroAcres applies EPA-labeled insecticides by drone across South Florida — faster, with less drift, and with chemical savings of 20–30% compared to ground rigs.",
    bullets: [
      "Target pests: thrips, whitefly, mites, scale, leafminer, armyworm",
      "EPA-labeled insecticides, biologicals and IGRs",
      "Electrostatic nozzle options for tight target deposition",
      "Designed for bee-safe windows and pollinator-conscious programs",
      "Full coverage reports for crop insurance and IPM records",
    ],
    crops: ["Tomato", "Squash", "Beans", "Citrus", "Avocado", "Mango", "Nursery"],
    nearby: ["miami-dade", "homestead-fl", "guide"],
    metaDescription:
      "Drone pesticide spraying across Florida — FAA-certified applicators, EPA-labeled chemistries, precision GPS swath control. Free quote — call 786-384-5030.",
  },
  "herbicide-miami": {
    path: "/herbicide-drone-application-miami/",
    title: "Herbicide Drone Application in Miami | AeroAcres",
    h1: "Herbicide Drone Application Across Miami-Dade",
    intro:
      "Weed pressure between rows, on ditch banks and along field edges is exactly where drones outperform tractors. AeroAcres delivers spot-spray and band-application herbicide programs across Miami-Dade — no soil disturbance, no compaction, no ground equipment in the field.",
    bullets: [
      "Band-application herbicide between grove or nursery rows",
      "Ditch-bank and fence-line spot programs",
      "Pre-emergent and post-emergent chemistries available",
      "No tractor passes — no tire damage to wet or rocky soils",
      "Coordinated with adjacent grower buffers and conservation zones",
    ],
    crops: ["Avocado", "Mango", "Nursery", "Sugarcane", "Sweet Corn", "Row Crops"],
    nearby: ["miami-dade", "homestead-fl", "pesticide-florida"],
    metaDescription:
      "Herbicide drone application across Miami-Dade — band-spray groves and nurseries with zero ground disturbance. AeroAcres FAA-certified pilots. Call 786-384-5030.",
  },
  "fungicide-homestead": {
    path: "/fungicide-drone-treatment-homestead/",
    title: "Fungicide Drone Treatment in Homestead, FL | AeroAcres",
    h1: "Fungicide Drone Treatment for Homestead Growers",
    intro:
      "South Florida humidity drives constant disease pressure — anthracnose on avocado, powdery mildew on cucurbits, rust in beans. AeroAcres applies fungicide programs by drone across Homestead with even canopy penetration, faster turnarounds and tighter spray windows.",
    bullets: [
      "Top-down canopy spray — chemical reaches leaf undersides",
      "Mobilize within 24–48 hours for active disease outbreaks",
      "Biological and conventional fungicide programs both supported",
      "Tank-mix with foliar nutrition for a single integrated pass",
      "Coverage reports archived for organic certification audits",
    ],
    crops: ["Avocado", "Mango", "Tomato", "Cucurbits", "Beans", "Lychee", "Nursery"],
    nearby: ["avocado-groves", "homestead-fl", "guide"],
    metaDescription:
      "Fungicide drone treatment for Homestead, FL growers. Same-week scheduling, top-down canopy penetration, EPA-labeled chemistries. AeroAcres — call 786-384-5030.",
  },

  // ===== Local service-area pages =====
  "homestead-area": {
    path: "/homestead-drone-spraying/",
    title: "Homestead Drone Spraying Service | AeroAcres",
    h1: "Drone Spraying in Homestead, FL — Local Service from Local Pilots",
    intro:
      "Homestead is our home — literally. AeroAcres is based at 24850 SW 197th Ave and we spray fields across every Homestead neighborhood from Krome Avenue to Eureka Drive. Our pilots know the local crop calendars, the prevailing wind patterns off Biscayne Bay, and the access challenges of every major grower in town.",
    bullets: [
      "Locally owned, FAA Part 137 certified, FDACS-licensed applicators",
      "Same-week scheduling and 24–48 hour emergency response in Homestead",
      "Long-standing relationships with Homestead avocado and lime growers",
      "$2M liability insurance — accepted by every major crop insurer",
      "Coverage reports formatted for organic certification audits",
    ],
    crops: ["Avocado", "Lime", "Mango", "Tomato", "Squash", "Nursery"],
    nearby: ["homestead-fl", "redland-fl", "florida-city-area"],
    metaDescription:
      "Local Homestead, FL drone spraying service — AeroAcres pilots based right in Homestead. FAA Part 137 certified, FDACS licensed, fully insured. Free quote: 786-384-5030.",
  },
  "miami-agriculture": {
    path: "/miami-drone-agriculture/",
    title: "Miami Drone Agriculture Service | AeroAcres",
    h1: "Miami Drone Agriculture — Precision Spraying for South Miami Farms",
    intro:
      "Miami's agricultural belt runs along the southern edge of the metro — Cutler Bay, Goulds, Princeton, Naranja and down to Homestead. AeroAcres serves every grower in that corridor with FAA-licensed drone applications, from row crops to ornamental nurseries and tropical fruit groves.",
    bullets: [
      "Coverage from Cutler Bay south to Florida City — every Miami agricultural zone",
      "Specialists in dense tropical-fruit canopy and ornamental nursery rows",
      "GPS-guided swath control saves 20–30% chemical vs. traditional ground rigs",
      "Same-day rush available for active pest or disease outbreaks",
      "Full coverage reports valid for crop-insurance and organic audits",
    ],
    crops: ["Avocado", "Mango", "Tomato", "Squash", "Beans", "Citrus", "Sugarcane", "Nursery"],
    nearby: ["miami-dade", "homestead-area", "broward-area"],
    metaDescription:
      "Miami drone agriculture service — AeroAcres pilots covering all South Miami farmland from Cutler Bay to Florida City. FAA Part 137 certified. Free quote: 786-384-5030.",
  },
  "broward-area": {
    path: "/broward-county-drone-farming/",
    title: "Broward County Drone Farming Service | AeroAcres",
    h1: "Broward County Drone Farming — Nurseries, Palm Farms & Specialty Crops",
    intro:
      "Broward County agriculture is dominated by ornamental nurseries, sod farms, palm operations and equestrian agriculture. AeroAcres serves Broward growers from our Homestead base — covering everything from Davie nurseries to Pompano Beach palm farms with FAA-licensed drone application crews.",
    bullets: [
      "Scheduled Broward County service area — book ahead for best slots",
      "Nursery-specialist programs: tight rows, mixed canopies, buffer zones",
      "Foliar nutrition and biological programs available for organic operations",
      "Coordinated bee-safe scheduling with on-site apiaries",
      "Same flight logs, GPS swath maps and coverage reports as our Miami-Dade work",
    ],
    crops: ["Ornamental Nursery", "Palm Farms", "Sod", "Specialty Citrus", "Equestrian Forage"],
    nearby: ["miami-dade", "miami-agriculture", "guide"],
    metaDescription:
      "Broward County drone farming service — AeroAcres FAA-certified pilots serving Broward nurseries, palm farms and specialty crops. Free quote: 786-384-5030.",
  },
  "florida-city-area": {
    path: "/florida-city-crop-spraying/",
    title: "Florida City Crop Spraying by Drone | AeroAcres",
    h1: "Florida City Crop Spraying by Drone",
    intro:
      "Florida City sits at the southern edge of Miami-Dade's row-crop belt, where sweet corn, tomatoes, beans and sugarcane stretch right up to the edge of the Everglades. AeroAcres delivers precision drone spraying across the entire Florida City agricultural zone, with mobilization from our Homestead base just minutes away.",
    bullets: [
      "Direct from our Homestead base — fastest response time in southern Miami-Dade",
      "Specialists in row crops, sugarcane edge fields, and irrigated tomato rows",
      "Pre-emergent and post-emergent herbicide programs available",
      "Coordinated with adjacent grower buffers and conservation zones",
      "Full GPS coverage maps and applied-rate reports on every job",
    ],
    crops: ["Sweet Corn", "Tomato", "Beans", "Okra", "Sugarcane", "Squash"],
    nearby: ["homestead-area", "miami-dade", "cost-florida"],
    metaDescription:
      "Florida City drone crop spraying — AeroAcres pilots serve every Florida City row-crop and sugarcane field. FAA Part 137 certified. Free quote: 786-384-5030.",
  },
  "citrus-florida": {
    path: "/citrus-drone-spraying-florida/",
    title: "Citrus Drone Spraying in Florida | AeroAcres",
    h1: "Citrus Drone Spraying Across South Florida",
    intro:
      "Florida citrus growers face constant pressure from greening (HLB), canker, psyllids and rust mite. AeroAcres delivers precision drone application of nutritionals, miticide programs and protectant chemistries directly into the canopy of Tahiti lime, Persian lime, lemon, grapefruit and orange blocks — without the soil compaction of ground rigs or the high cost of manned aerial applicators.",
    bullets: [
      "Foliar nutrition + protectant tank-mixes for HLB-affected blocks",
      "Targeted miticide and psyllid programs flown on tight intervals",
      "Top-down canopy penetration — chemical reaches the leaf underside",
      "Same-week scheduling for South Florida lime and lemon growers",
      "EPA-compliant chemistries and full coverage reports",
    ],
    crops: ["Tahiti Lime", "Persian Lime", "Lemon", "Grapefruit", "Orange", "Tangelo"],
    nearby: ["homestead-fl", "miami-dade", "avocado-groves"],
    metaDescription:
      "Citrus drone spraying in South Florida — AeroAcres applies nutrition, miticide and protectant programs into lime, lemon and orange canopies. Free quote: 786-384-5030.",
  },
  "nursery-florida": {
    path: "/nursery-drone-application-florida/",
    title: "Nursery Drone Application in South Florida | AeroAcres",
    h1: "Drone Application for South Florida Ornamental Nurseries",
    intro:
      "Ornamental nurseries across the Redland, Homestead and Broward run tight rows, mixed canopy heights and buffer-sensitive borders — exactly the conditions where drones outperform every other application method. AeroAcres flies bi-weekly and monthly programs for palm farms, foliage operations, hibiscus and ornamental tree nurseries with FAA Part 137 certified pilots.",
    bullets: [
      "Tight-row band application with no ground equipment in the aisles",
      "Bee-safe scheduling coordinated with on-site apiaries and adjacent growers",
      "Biological and organic-program chemistry support",
      "Foliar nutrition + protectant tank-mixes in one pass",
      "Coverage reports formatted for organic and crop-insurance audits",
    ],
    crops: ["Palms", "Foliage", "Hibiscus", "Ornamental Trees", "Bromeliad", "Liner Stock"],
    nearby: ["broward-area", "redland-fl", "miami-agriculture"],
    metaDescription:
      "Drone application for South Florida ornamental nurseries — AeroAcres flies tight-row, buffer-sensitive programs for palms, foliage and hibiscus. Call 786-384-5030.",
  },
};

export const ALL_SEO_KEYS = Object.keys(SEO_PAGES);
